import { render } from "./Pedigree.vue?vue&type=template&id=7e4854ee&scoped=true"
import script from "./Pedigree.vue?vue&type=script&lang=js"
export * from "./Pedigree.vue?vue&type=script&lang=js"

import "./Pedigree.vue?vue&type=style&index=0&id=7e4854ee&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4854ee"]])

export default __exports__